import React, {useState} from 'react';
import {getUserFriendlyErrorMessage} from '@/utils/errorHandling.ts';
import {
  Button,
  ButtonVariant,
  Label,
  useModal,
  useToast
} from '@fs/uikit-react';
import styles from './CategoryModalDelete.module.css';
import {Category} from '@/shared/model/category.ts';
import {CategoriesApi} from '@/shared/api/CategoriesApi.ts';
import {ApiError} from "@/services/api";

interface DeleteCategoryModalProps {
  category: Category;
  onSuccess: () => void;
}

const CategoryModalDelete: React.FC<DeleteCategoryModalProps> = ({ category, onSuccess }) => {
  const { closeModal } = useModal();
  const toast = useToast();
  const [isDeleting, setIsDeleting] = useState(false);

  const handleDelete = async () => {
    setIsDeleting(true);

    try {
      await CategoriesApi.delete(category.id);

      toast.showSuccessToast('Успішно', 'Категорію видалено');

      closeModal();
      onSuccess();
    } catch (error) {
      console.error('Error deleting category:', error);
      toast.showErrorToast('Помилка видалення категорії',
        getUserFriendlyErrorMessage(error as ApiError));
    } finally {
      setIsDeleting(false);
    }
  };

  return (
    <div className={styles.modalContent}>
      <Label
        text={`Ви впевнені, що хочете видалити категорію "${category.name}"?\nПовернути її назад в каталог буде неможливо.`}
      />

      <div className={styles.buttonGroup}>
        <Button
          variant={ButtonVariant.DESTRUCTIVE}
          title={isDeleting ? 'Видалення...' : 'Видалити'}
          onClick={handleDelete}
          disabled={isDeleting}
        />
        <Button
          variant={ButtonVariant.SECONDARY}
          title="Скасувати"
          onClick={closeModal}
        />
      </div>
    </div>
  );
};

export default CategoryModalDelete;
